// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "-legacy." + {"102":"ce2b6861","133":"427b3e98","182":"a1f55066"}[chunkId] + ".js";
};